var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.688 14.424C8.16533 14.4053 7.66133 14.3447 7.176 14.242C6.7 14.1393 6.308 14.0087 6 13.85V12.324C6.83067 12.7253 7.72667 12.9493 8.688 12.996V9.888C7.77333 9.51467 7.11067 9.09933 6.7 8.642C6.28933 8.18467 6.084 7.61533 6.084 6.934C6.084 6.25267 6.31733 5.67867 6.784 5.212C7.25067 4.736 7.88533 4.43267 8.688 4.302V3H10.2V4.26C10.956 4.316 11.6607 4.48867 12.314 4.778V6.262C11.6047 5.91667 10.9 5.72533 10.2 5.688V8.726C10.8253 8.99667 11.3247 9.26267 11.698 9.524C12.0713 9.78533 12.3513 10.0887 12.538 10.434C12.7247 10.7793 12.818 11.1993 12.818 11.694C12.818 12.422 12.5987 13.0147 12.16 13.472C11.7213 13.9293 11.068 14.2233 10.2 14.354V15.67H8.688V14.424ZM8.688 5.884C8.212 6.08933 7.974 6.43933 7.974 6.934C7.974 7.19533 8.03 7.41467 8.142 7.592C8.254 7.76 8.436 7.914 8.688 8.054V5.884ZM10.2 12.772C10.6667 12.548 10.9 12.184 10.9 11.68C10.9 11.428 10.844 11.218 10.732 11.05C10.62 10.8727 10.4427 10.714 10.2 10.574V12.772Z",
    fill: "#13100D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.e5bd7961b85f8487ab144beec4fbb6f3.svg";
export { ForwardRef as ReactComponent };